"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx6 = _interopRequireDefault(require("clsx"));

var _IconButton = require("../IconButton");

var _IconSvg = require("@sivasifr/icons/IconSvg");

var _useForkRef = _interopRequireDefault(require("../utils/useForkRef"));

var _unsupportedProp = _interopRequireDefault(require("../utils/unsupportedProp"));

var _capitalize = _interopRequireDefault(require("../utils/capitalize"));

require("../Avatar");

var _ChipModule = _interopRequireDefault(require("./Chip.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


var Chip = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _clsx4;

  var avatarProp = props.avatar,
      className = props.className,
      clickableProp = props.clickable,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      deleteIconProp = props.deleteIcon,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      iconProp = props.icon,
      label = props.label,
      onClick = props.onClick,
      onDelete = props.onDelete,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      other = _objectWithoutProperties(props, ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);

  var chipRef = _react["default"].useRef(null);

  var handleRef = (0, _useForkRef["default"])(chipRef, ref);

  var handleDeleteIconClick = function handleDeleteIconClick(event) {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();

    if (onDelete) {
      onDelete(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (onKeyDown) {
      onKeyDown(event);
    } // Ignore events from children of `Chip`.


    if (event.currentTarget !== event.target) {
      return;
    }

    if ([' ', 'Enter', 'Backspace', 'Delete', 'Escape'].indexOf(event.key) !== -1) {
      event.preventDefault();
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    if (onKeyUp) {
      onKeyUp(event);
    } // Ignore events from children of `Chip`.


    if (event.currentTarget !== event.target) {
      return;
    }

    var key = event.key;

    if (onClick && (key === ' ' || key === 'Enter')) {
      onClick(event);
    } else if (onDelete && (key === 'Backspace' || key === 'Delete')) {
      onDelete(event);
    } else if (key === 'Escape' && chipRef.current) {
      chipRef.current.blur();
    }
  };

  var clickable = clickableProp !== false && onClick ? true : clickableProp;
  var small = size === 'small';
  var deleteIcon = null;

  if (onDelete) {
    var _clsx;

    var customClasses = (0, _clsx6["default"])((_clsx = {}, _defineProperty(_clsx, _ChipModule["default"].deleteIconSmall, small), _defineProperty(_clsx, _ChipModule["default"]["deleteIconColor".concat((0, _capitalize["default"])(color))], color !== 'default' && variant !== 'outlined'), _defineProperty(_clsx, _ChipModule["default"]["deleteIconOutlinedColor".concat((0, _capitalize["default"])(color))], color !== 'default' && variant === 'outlined'), _clsx));
    deleteIcon = deleteIconProp && /*#__PURE__*/_react["default"].isValidElement(deleteIconProp) ? /*#__PURE__*/_react["default"].cloneElement(deleteIconProp, {
      className: (0, _clsx6["default"])(deleteIconProp.props.className, _ChipModule["default"].deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    }) : /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
      className: (0, _clsx6["default"])('chip--deleteIcon', customClasses),
      onClick: handleDeleteIconClick
    }, /*#__PURE__*/_react["default"].createElement(_IconSvg.IconSvg, {
      name: "times"
    }));
  }

  var avatar = null;

  if (avatarProp && /*#__PURE__*/_react["default"].isValidElement(avatarProp)) {
    avatar = /*#__PURE__*/_react["default"].cloneElement(avatarProp, {
      className: (0, _clsx6["default"])('chip--avatar', avatarProp.props.className, _defineProperty({
        'chip--avatarSmall': small
      }, "chip--avatarColor".concat((0, _capitalize["default"])(color)), color !== 'default'))
    });
  }

  var icon = null;

  if (iconProp && /*#__PURE__*/_react["default"].isValidElement(iconProp)) {
    icon = /*#__PURE__*/_react["default"].cloneElement(iconProp, {
      className: (0, _clsx6["default"])('chip--icon', iconProp.props.className, _defineProperty({
        'chip--iconSmall': small
      }, "chip--iconColor".concat((0, _capitalize["default"])(color)), color !== 'default'))
    });
  }

  if (process.env.NODE_ENV !== 'production') {
    if (avatar && icon) {
      console.error('Siva-UI: the Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
    }
  }

  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    role: clickable || onDelete ? 'button' : undefined,
    className: (0, _clsx6["default"])(_ChipModule["default"].chip, (_clsx4 = {}, _defineProperty(_clsx4, _ChipModule["default"].disabled, disabled), _defineProperty(_clsx4, _ChipModule["default"].sizeSmall, small), _defineProperty(_clsx4, _ChipModule["default"]["color".concat((0, _capitalize["default"])(color))], color !== 'default'), _defineProperty(_clsx4, _ChipModule["default"].clickable, clickable), _defineProperty(_clsx4, _ChipModule["default"]["clickableColor".concat((0, _capitalize["default"])(color))], clickable && color !== 'default'), _defineProperty(_clsx4, _ChipModule["default"].deletable, onDelete), _defineProperty(_clsx4, _ChipModule["default"]["deletableColor".concat((0, _capitalize["default"])(color))], onDelete && color !== 'default'), _defineProperty(_clsx4, _ChipModule["default"].outlined, variant === 'outlined'), _defineProperty(_clsx4, _ChipModule["default"].outlinedPrimary, variant === 'outlined' && color === 'primary'), _defineProperty(_clsx4, _ChipModule["default"].outlinedSecondary, variant === 'outlined' && color === 'secondary'), _clsx4), className),
    tabIndex: clickable || onDelete ? 0 : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef
  }, other), avatar || icon, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _clsx6["default"])(_ChipModule["default"].label, _defineProperty({}, _ChipModule["default"].labelSmall, small))
  }, label), deleteIcon);
});

Chip.propTypes = {
  /**
    * Avatar element.
    */
  avatar: _propTypes["default"].element,

  /**
    * This prop isn't supported.
    * Use the `component` prop if you need to change the children structure.
    */
  children: _unsupportedProp["default"],

  /**
    * Override or extend the styles applied to the component.
    */
  className: _propTypes["default"].string,

  /**
    * If true, the chip will appear clickable, and will raise when pressed,
    * even if the onClick prop is not defined.
    * If false, the chip will not be clickable, even if onClick prop is defined.
    * This can be used, for example,
    * along with the component prop to indicate an anchor Chip is clickable.
    */
  clickable: _propTypes["default"].bool,

  /**
    * The color of the component. It supports those theme colors that make sense for this component.
    */
  color: _propTypes["default"].oneOf(['default', 'primary', 'secondary', 'accent']),

  /**
    * The component used for the root node.
    * Either a string to use a DOM element or a component.
    */
  component: _propTypes["default"].elementType,

  /**
    * Override the default delete icon element. Shown only if `onDelete` is set.
    */
  deleteIcon: _propTypes["default"].element,

  /**
    * If `true`, the chip should be displayed in a disabled state.
    */
  disabled: _propTypes["default"].bool,

  /**
    * Icon element.
    */
  icon: _propTypes["default"].element,

  /**
    * The content of the label.
    */
  label: _propTypes["default"].node,

  /**
    * @ignore
    */
  onClick: _propTypes["default"].func,

  /**
    * Callback function fired when the delete icon is clicked.
    * If set, the delete icon will be shown.
    */
  onDelete: _propTypes["default"].func,

  /**
    * @ignore
    */
  onKeyDown: _propTypes["default"].func,

  /**
    * @ignore
    */
  onKeyUp: _propTypes["default"].func,

  /**
    * The size of the chip.
    */
  size: _propTypes["default"].oneOf(['small', 'medium']),

  /**
    * The variant to use.
    */
  variant: _propTypes["default"].oneOf(['default', 'outlined'])
};
var _default = Chip;
exports["default"] = _default;